/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Container, Button, Spinner, Modal } from "react-bootstrap";
import usePublicAssessmentDetails from "./usePublicAssessmentDetails";
import MainLayout from "../../../_components/Common/MainLayout";
function ViewJobDetail() {
  const {
    userData,
    assessmentDetails,
    isAcceptLoading,
    loading,
    declineAssessmentModal,
    declineLoading,
    handleIsDeclineModal,
    onAcceptAssessment,
    onLoginClick,
    onDeclineAssessmentClick,
    onStartAssessmentClick,
  } = usePublicAssessmentDetails();
  return (
    <MainLayout>
      <Container>
        {loading ? (
          <div className="text-center">
            <Spinner variant="primary" />
          </div>
        ) : (
          <div className="row">
            <div className="col-xl-8">
              <div className="bg-white border border-radius-10 m-4 p-3">
                <div className="border-radius-10 my-4">
                  <img src={"/assets/images/logo.png"} alt="user" />
                </div>
                <h2>Proving Your Skills - Time for the Assessment Challenge</h2>
                <div className="text-grey-4 my-3">
                  Hi{" "}
                  <span className="text-capitalize font-weight-semi text-dark-2">
                    {userData?.full_name}
                  </span>{" "}
                  ,<br />
                  <p className="mb-3">
                    We are excited to inform you that you have been assigned an
                    assessment kit for the job, through Jigsaw, a leading
                    recruitment platform that is revolutionizing the hiring
                    process.
                  </p>
                  <p className="mb-4">
                    Your qualifications and experience have caught our
                    attention, and we believe you could be a great fit for our
                    team. To take the next step, please follow the steps below
                    to access the assessment kit and begin the journey to
                    potentially joining our dynamic workforce.
                  </p>
                  <p className="mb-1">Warm Regards,</p>
                  <p className=" mb-0">
                    <span>Jigsaw</span>
                  </p>
                </div>

                <div className="border-bottom mb-2">
                  <h3 className="my-2 text-capitalize">
                    Assessment Name: {assessmentDetails?.title}
                  </h3>
                  {assessmentDetails && assessmentDetails?.additional_notes ? (
                    <div className="d-flex">
                      <h3>Note: </h3>

                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            assessmentDetails &&
                            assessmentDetails?.additional_notes,
                        }}
                      />
                    </div>
                  ) : null}
                  <ul className="text-grey-4 pt-2">
                    <li className="mb-3">
                      {" "}
                      {Array.isArray(assessmentDetails?.skills) &&
                        assessmentDetails.skills.map((item) => (
                          <p
                            className="bg-grey-3 d-inline-block rounded h4 font-weight-normal px-2 py-1 text-capitalize mr-2"
                            key={item?.id}
                          >
                            {item.skill_id && item.skill_id?.skill}
                          </p>
                        ))}
                      <p className="text-capitalize">Skills</p>
                    </li>
                    <li className="mb-3">
                      <p className="text-dark-2 font-weight-semi">
                        {assessmentDetails?.total_questions}
                      </p>
                      <p className="text-capitalize">Questions</p>
                    </li>
                    <li className="mb-3">
                      <p className="text-dark-2 font-weight-semi">
                        ~{assessmentDetails?.total_questions * 3} mins
                      </p>
                      <p className="text-capitalize">Estimate time</p>
                    </li>
                  </ul>
                  {userData ? (
                    <>
                      {userData?.role === "candidate" ? (
                        <>
                          {assessmentDetails?.assigned_assessment_details ? (
                            <div className="py-4 text-grey-4">
                              {assessmentDetails?.assigned_assessment_details &&
                              assessmentDetails?.assigned_assessment_details
                                ?.status == "accepted" ? (
                                <button
                                  className="btn btn-primary px-3 py-2 fs-14"
                                  onClick={() =>
                                    onStartAssessmentClick(
                                      assessmentDetails?.assigned_assessment_details &&
                                        assessmentDetails
                                          ?.assigned_assessment_details?.id
                                    )
                                  }
                                >
                                  {isAcceptLoading ? (
                                    <Spinner variant="green" />
                                  ) : (
                                    "Let's Start"
                                  )}
                                </button>
                              ) : assessmentDetails?.assigned_assessment_details &&
                                assessmentDetails?.assigned_assessment_details
                                  ?.status == "assigned" ? (
                                <>
                                  <div className="actions d-flex align-items-center">
                                    <button
                                      className="btn custom-tag tag-green px-3 py-2 fs-14"
                                      onClick={() =>
                                        onAcceptAssessment(
                                          assessmentDetails?.id
                                        )
                                      }
                                    >
                                      {isAcceptLoading ? (
                                        <Spinner variant="green" />
                                      ) : (
                                        "Accept"
                                      )}
                                    </button>
                                    <button
                                      className="btn custom-tag tag-rejected ml-3 py-2 fs-14 px-3"
                                      onClick={handleIsDeclineModal}
                                    >
                                      Decline
                                    </button>
                                  </div>
                                </>
                              ) : assessmentDetails?.assigned_assessment_details &&
                                assessmentDetails?.assigned_assessment_details
                                  ?.status == "completed" ? (
                                <span className="custom-tag px-3 tag-interview rounded-pill fs-14 opacity-three-fourth">
                                  <span className="custom-tag tag-interview rounded-pill bg-white mr-2">
                                    completed
                                  </span>
                                  You have completed this assessment
                                </span>
                              ) : assessmentDetails?.assigned_assessment_details &&
                                assessmentDetails?.assigned_assessment_details
                                  ?.status == "shortlisted" ? (
                                <span className="custom-tag px-3 tag-green rounded-pill fs-14 opacity-three-fourth">
                                  <span className="custom-tag tag-green rounded-pill bg-white mr-2">
                                    Shortlisted
                                  </span>
                                  You have been shortlisted
                                </span>
                              ) : assessmentDetails?.assigned_assessment_details &&
                                assessmentDetails?.assigned_assessment_details ===
                                  "declined" ? (
                                <span className="custom-tag px-3 tag-rejected rounded-pill fs-14 opacity-three-fourth text-danger">
                                  <span className="custom-tag tag-rejected rounded-pill bg-white mr-2">
                                    Declined
                                  </span>
                                  You have declined the assessment kit
                                </span>
                              ) : assessmentDetails?.assigned_assessment_details &&
                                assessmentDetails?.assigned_assessment_details ===
                                  "rejected" ? (
                                <span className="custom-tag tag-rejected rounded-pill fs-14 opacity-three-fourth text-danger">
                                  <span className="custom-tag tag-rejected rounded-pill bg-white mr-2">
                                    Rejected
                                  </span>
                                  You have been rejected to this assessment kit
                                </span>
                              ) : null}
                            </div>
                          ) : (
                            <div className="actions d-flex align-items-center mb-4">
                              <button
                                className="btn custom-tag tag-green px-3 py-2 fs-14"
                                onClick={() =>
                                  onAcceptAssessment(assessmentDetails?.id)
                                }
                              >
                                {isAcceptLoading ? (
                                  <Spinner variant="green" />
                                ) : (
                                  "Accept"
                                )}
                              </button>
                            </div>
                          )}
                        </>
                      ) : null}
                    </>
                  ) : (
                    <div>
                      <button
                        onClick={onLoginClick}
                        className="btn btn-primary mb-3"
                      >
                        Login to Accept
                      </button>
                    </div>
                  )}
                </div>
                <div className="text-grey-4 pt-3">
                  Thank you for your continued dedication to the Jigsaw
                  community. If you have any questions or need assistance,
                  please don't hesitate to reach out to us at hi@jigsaw.com.
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
      <Modal
        show={declineAssessmentModal}
        centered
        size="sm"
        onHide={() => handleIsDeclineModal()}
        className="common-modal"
      >
        <Modal.Header>
          <h2>Confirmation</h2>
        </Modal.Header>
        <Modal.Body className="py-4">
          <h3>Do you really want to decline this Assessment?</h3>
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button variant="primary" onClick={() => onDeclineAssessmentClick()}>
            {declineLoading ? <Spinner variant="white" /> : "Yes"}
          </Button>
          <Button variant="secondary" onClick={() => handleIsDeclineModal()}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </MainLayout>
  );
}

export default ViewJobDetail;
